import { Theme as CaiMaterialTheme } from '@cai/material';
import { Theme } from 'connex-cds';

const useThemeConfig = WrappedComponent => {
  const EnhancedComponent = props => {
    const { themeName } = Theme.useThemeContext();

    return (
      <CaiMaterialTheme.ThemeProvider themeName={themeName}>
        <WrappedComponent {...props} />
      </CaiMaterialTheme.ThemeProvider>
    );
  };

  return EnhancedComponent;
};

export default useThemeConfig;
